<script>
  import Number from "./Number.svelte";

  export let stats = [];
  export let format;
  export let suffix = "";
</script>

<span class="c" tabIndex="0">
  <div class="tooltip">
    {#each stats as { label, value }, i}
      <div class="stat">
        {label}
        <div class="value">
          <strong>
            <Number number="{value}" {format} />
          </strong>
          {suffix}
        </div>
      </div>
    {/each}
  </div>
  <span class="contents">
    <slot />
  </span>
</span>

<style>
  .c {
    display: inline-block;
    position: relative;
    cursor: help;
  }
  .tooltip {
    position: absolute;
    top: 0;
    left: 50%;
    background: white;
    padding: 0.6em 1em;
    transform: translate(-50%, -100%);
    min-width: 20em;
    max-width: 60vw;
    font-size: 0.86em;
    line-height: 1.6em;
    opacity: 0;
    box-shadow: var(--box-shadow);
    pointer-events: none;
    transition: all 0.2s ease-out;
  }
  .c:hover .tooltip,
  .c:focus .tooltip {
    opacity: 1;
    transform: translate(-50%, calc(-0.3em + -100%));
  }
  strong {
    color: var(--c2);
    font-weight: 800;
  }
  .stat {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
  }
  .value {
    padding-left: 1em;
  }
  .c:hover .contents {
    padding: 0 0.2em;
    margin: 0 -0.2em;
    background: white;
  }
  @media (max-width: 800px) {
    .tooltip {
      min-width: 0;
      width: 60vw;
      max-width: 13em;
      line-height: 1.3em;
    }
    .stat {
      display: block;
      white-space: normal;
    }
    .stat + .stat {
      margin-top: 1em;
    }
    .value {
      padding-left: 0;
      padding-top: 0.3em;
    }
  }
</style>
